import React from "react"
import { CreateComponent } from "components/utils/CreateComponent"
import info_language from "img/player/info_language.svg"
import info_age_rating from "img/player/info_age_rating.svg"
import info_country from "img/player/info_country.svg"
import content_rating from "img/player/content_rating.svg"
import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"
import { analyticsScreen, analyticsMeta } from "store/qlapi/LogService"
import { appFeatures } from "../../AppFeatures"
import { eventId, genres, productionLocation, isSeries, language, productionYear, ageRating, season, episode, episodeName } from "utils/EventHelpers"
import { languageName, countryName} from "utils/IntlManager"
import { l10n } from "store/lang/L10n"

import "./EpgChannelDetailsInfo.css"

const helperFilterElem = i => i !== null && i !== false && i !== "" && i !== void 0

// MTVW-808: prefix and other parameters are not used
//export const EpgChannelDetailsToolsInfo = CreateComponent(null, false, true, ({ oEvent, origin, prefix = "", suffix = "", joinTxt = " | ", empty = null }) => {
export const EpgChannelDetailsToolsInfo = CreateComponent(null, false, true, ({ oEvent, origin }) => {
	const [innerWidth, setInnerWidth] = React.useState(window.innerWidth)

	React.useEffect(() => {
		window.addEventListener("resize", handleResize, false)
		handleResize()
		return (() => {
			window.removeEventListener("resize", handleResize, false)
		})
	}, [])

	const handleResize = () => {
		setInnerWidth(window.innerWidth)
	}

	let genresArray = genres(oEvent)?.filter(helperFilterElem) ?? []
	// MTVW-1078: commented, French will not return search result for "Séries"
	/*
	for (var i = 0; i < genresArray.length; i++) {
		// replace "Serien" with localized text
		genresArray[i] = genresArray[i].replace("Serien", l10n.featureSearchFilterCategorySeries)
	}
	*/
	// check if we have to add Series
	if (isSeries(oEvent) && !genresArray.includes(l10n.csSeries)) genresArray.unshift(l10n.csSeries)
	// remove potential duplicates
	genresArray = genresArray.filter((item, index) => genresArray.indexOf(item) === index)
	const loc = [productionLocation(oEvent)]?.filter(helperFilterElem).join(" ")
	let location = loc
	if (location?.length > 0) {
		// use just the 1st one
		location = location.split(',')[0]
		location = countryName(location)
	}
	console.debug("genres=", genres(oEvent), genresArray, loc, location)
	//console.debug("regionName", regionNamesForLanguage.of(appFeatures.locale), location.split(',')[0])

	const widthBreakTablet = 800
	const widthBreakMobile = 540

	const InfoYear = () => {
		return productionYear(oEvent) !== null && (
			<div className="metaInfoYear">
				{productionYear(oEvent)}
			</div>
		)
	}

	const InfoGenres = () => {
		return (
			<div className="metaInfoGenreContainer">
				{genresArray.map((item, idx) => (
					<div key={origin + idx} >
						{idx > 0 ? <span className="metaInfoGenreSeparator">•</span> : <></>}
						<span className="metaInfoGenre"
							onClick={(e) => {
								e.preventDefault()
								e.stopPropagation()
								console.debug("InfoGenres callingContex %s, genre %s", rootStore.page.OverlayEventDetails.callingContext, item)
								rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.genreRelatedPrograms, genre: item })
								// no back button if in LiveTv
								//if (rootStore.page.Player.isPlayerOnOverlay) {
								if (rootStore.page.OverlayEventDetails.isVisible) {
									rootStore.page.OverlayEventDetails.pushActivity({ type: 'related', id: eventId(oEvent) })
								}
								rootStore.page.OverlayEventDetails.setGenre(item).setComponentType(rootStore.page.Search.CATEGORY_GENRES).setShow(true, CALLING_CONTEXT_TYPE.TvGuide)
							}}
						>{item}</span>
					</div>
				)
				)}
			</div>
		)
	}

	const InfoLanguage = () => {
		return language(oEvent) !== null && (
			<div className="metaInfoLanguage">
				<div className="metaInfoIconContainer">
					<img src={info_language} alt="" className="metaInfoIcon"></img>
				</div>
				<div className="metaInfoLanguageLabel">
					{language(oEvent)}
				</div>
			</div>
		)
	}

	const InfoCountry = () => {
		return location?.length > 0 && (
			<div className="metaInfoCountry">
				<div className="metaInfoIconContainer">
					<img src={info_country} alt="" className="metaInfoIcon"></img>
				</div>
				<div className="metaInfoCountyLabel">
					{location}
				</div>
			</div>
		)
	}

	const InfoAgeRating = () => {
		return ageRating(oEvent) && ageRating(oEvent) !== "FSK0" && (
			<div className="metaInfoAgeRating">
				<div className="metaInfoIconContainer">
					<img src={info_age_rating} alt="" className="metaInfoIcon"></img>
				</div>
				<div className="metaInfoAgeRatingLabel">
					{`${ageRating(oEvent)}`}
				</div>
			</div>
		)
	}

	const InfoStarRating = () => {
		return oEvent?.tmdbRating > 0 && (
			<div className="metaInfoCountry">
				<div className="metaInfoIconContainer">
					<img src={content_rating} alt="" className="metaInfoIcon"></img>
				</div>
				<div className="metaInfoCountyLabel">
					{oEvent?.tmdbRating?.toFixed(1)}
				</div>
			</div>
		)
	}

	const DesktopLayout = [
		{ component: () => <InfoYear /> },
		{ component: () => <InfoGenres /> },
		{ component: () => <InfoLanguage /> },
		{ component: () => <InfoCountry /> },
		{ component: () => <InfoAgeRating /> },
		{ component: () => <InfoStarRating /> },
	]

	const TabletLayout = [
		{ component: () => { return (<InfoGenres />) } },
		// remaining items 2nd line
		{ component: () => { return (<><div className="metaInfoDividerLight" /><div className="metaInfoGenreContainer"><InfoYear /><InfoLanguage /><InfoCountry /><InfoAgeRating /><InfoStarRating /></div> </>) } },
		// else return nothing
		{ component: () => { return (<></>) } },
		{ component: () => { return (<></>) } },
		{ component: () => { return (<></>) } },
		{ component: () => { return (<></>) } },
	]

	const MobileLayout = [
		{ component: () => { return (<InfoGenres />) } },
		// 2nd line
		{ component: () => { return (<><div className="metaInfoDividerLight" /><div className="metaInfoGenreContainer"><InfoYear /><InfoAgeRating /><InfoStarRating /></div> </>) } },
		// rd line
		{ component: () => { return (<><div className="metaInfoDividerLight" /><div className="metaInfoGenreContainer"><InfoLanguage /><InfoCountry /></div> </>) } },
		// else return nothing
		{ component: () => { return (<></>) } },
		{ component: () => { return (<></>) } },
		{ component: () => { return (<></>) } },
	]

	const detailsInfo = (ix) => {
		let layout = DesktopLayout
		if (innerWidth <= widthBreakTablet) layout = TabletLayout
		if (innerWidth <= widthBreakMobile) layout = MobileLayout
		return layout[ix]
	}

	return oEvent?.event?.id ?
		<>
			{/* MTVW-808: tweaks, style={{ marginTop: 18 }} */}
			{innerWidth <= widthBreakTablet && (<div style={{ marginTop: 18 }} className="metaInfoDivider" />)}
			<div className="metaInfoContainer" data-test="detail_info_tech_description">
				{detailsInfo(0).component()}
				{detailsInfo(1).component()}
				{detailsInfo(2).component()}
				{detailsInfo(3).component()}
				{detailsInfo(4).component()}
				{detailsInfo(5).component()}
			</div>
			{/* MTVW-808: tweaks, style={{ marginBottom: 10 }} */}
			{innerWidth <= widthBreakTablet && (<div style={{ marginBottom: 10 }} className="metaInfoDivider" />)}
		</>
		: <div style={{ height: 48.7, width: 100 }}></div>
})


// MTVW-810
export const EpgChannelDetailsToolsTitleSecondary = CreateComponent(null, false, true, ({ innerWidth, widthBreak, oEventData, prefix = "", suffix = "", joinTxt = ", ", empty = null }) => {
	const t = [season(oEventData) ? l10n.featureEpisodeSeasonNumber?.format(season(oEventData)) : null, episode(oEventData) ? l10n.featureEpisodeEpisodeNumber?.format(episode(oEventData)) + ` • ` : null, episodeName(oEventData) ? episodeName(oEventData) : null]?.filter(
		helperFilterElem
	)

	const padding = innerWidth <= widthBreak ? "27px" : "unset"
	let details = t?.filter(helperFilterElem).join(joinTxt).replace("• ,", "• ")
	if (details?.indexOf(" • ") === details?.length - 3) details = details.replace(" • ", "")
	return t?.length > 0 ? (
		// use <span> for usage in EpgChannel, otherwise ellipsis will not be shown
		(<span style={{ paddingBottom: padding }}>
			{prefix}
			{details}
			{suffix}
		</span>)
	) : (
		<div style={{ paddingBottom: "unset" }} />
	);
})
